import ApiClient from 'clients/api_client'
import SpecialDestinationCandidate from 'entities/user_notice/special_destination_candidate'

export default class SpecialDestinationCandidateClient {
  static getSpecialDestinationCandidates(target) {
    const url = Routes.searchUserNoticeSpecialDestinationCandidatesPath()
    const params = {
      target
    }
    return ApiClient.post(url, params).then(({ data }) => ({
      specialDestinationCandidates: data.map(s => SpecialDestinationCandidate.fromJson(s))
    }))
  }
}
